import { HomePage } from './../home/home';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController
} from "ionic-angular";
import { ToastController } from "ionic-angular";
import { TranslateService } from '@ngx-translate/core';

import { ContactSocketPage } from './../contact-socket/contact-socket';
import { BqApiProvider } from '../../providers/bq-api/bq-api';
import { NeedsDiagnosisPage } from '../needs-diagnosis/needs-diagnosis';




@IonicPage()
@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html'
})
export class WelcomePage {
  public welcomeComment: string;
  public workerComment: string;
  public p1Selection: number;
  public p2Selection: number;
  public p3Selection: number;
  public p4Selection: number;
  public p5Selection: number;
  public p6Selection: number;
  public p7Selection: number;
  public p8Selection: number;
  public p9Selection: number;
  public p10Selection: number;
  public p11Selection: number;

  constructor(
    private translate: TranslateService,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private bqApi: BqApiProvider
  ) {
    this.p1Selection = 0;
    this.p2Selection = 0;
    this.p3Selection = 0;
    this.p4Selection = 0;
    this.p5Selection = 0;
    this.p6Selection = 0;
    this.p7Selection = 0;
    this.p8Selection = 0;
    this.p9Selection = 0;
    this.p10Selection = 0;
    this.p11Selection = 0;
    this.welcomeComment = '';
    this.workerComment = '';
  }

  ionViewDidLoad() {
    this.p1Selection = this.bqApi.getStep(1) || 0;
    this.p2Selection = this.bqApi.getStep(2) || 0;
    this.p3Selection = this.bqApi.getStep(3) || 0;
    this.p4Selection = this.bqApi.getStep(4) || 0;
    this.p5Selection = this.bqApi.getStep(5) || 0;
    this.p6Selection = this.bqApi.getStep(6) || 0;
    this.p7Selection = this.bqApi.getStep(7) || 0;
    this.p8Selection = this.bqApi.getStep(8) || 0;
    this.p9Selection = this.bqApi.getStep(9) || 0;
    this.p10Selection = this.bqApi.getStep(10) || 0;
    this.p11Selection = this.bqApi.getStep(11) || 0;
    this.welcomeComment = this.bqApi.getComment(0);
    this.workerComment = this.bqApi.getComment(50);
  }

  nextStep() {
    if (this.p1Selection !== 0) {
      this.bqApi.setStep(1, this.p1Selection);
    }
    if (this.p2Selection !== 0) {
      this.bqApi.setStep(2, this.p2Selection);
    }
    if (this.p3Selection !== 0) {
      this.bqApi.setStep(3, this.p3Selection);
    }
    if (this.p4Selection !== 0) {
      this.bqApi.setStep(4, this.p4Selection);
    }
    if (this.p5Selection !== 0) {
      this.bqApi.setStep(5, this.p5Selection);
    }
    if (this.p6Selection !== 0) {
      this.bqApi.setStep(6, this.p6Selection);
    }
    if (this.p7Selection !== 0) {
      this.bqApi.setStep(7, this.p7Selection);
    }
    if (this.p8Selection !== 0) {
      this.bqApi.setStep(8, this.p8Selection);
    }
    if (this.p9Selection !== 0) {
      this.bqApi.setStep(9, this.p9Selection);
    }
    if (this.p10Selection !== 0) {
      this.bqApi.setStep(10, this.p10Selection);
    }
    if (this.p11Selection !== 0) {
      this.bqApi.setStep(11, this.p11Selection);
    }

    if (this.welcomeComment !== '') {
      this.bqApi.setComment(0, this.welcomeComment);
    }

    if (this.workerComment !== '') {
      this.bqApi.setComment(50, this.workerComment);
    }

    this.bqApi.syncSteps();

    this.viewCtrl.dismiss();

    if (this.p11Selection === 4) {
      this.navCtrl.push(NeedsDiagnosisPage);
    } else {
      this.navCtrl.push(ContactSocketPage);
    }
  }

  previousStep() {
    this.viewCtrl.dismiss();
    this.navCtrl.push(HomePage);
  }

  validate() {
    this.bqApi.upload();
  }
}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts